import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Avatar,
  ClickAwayListener,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Radio,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import jwt_decode from "jwt-decode";
import QRCode from "qrcode.react";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import companyProfileLight from "../../src/assets/USA_Images/dashboard_icons/defaultCompany.svg";
import companyProfileDark from "../../src/assets/USA_Images/dashboard_icons/defaultCompanyDark.svg";
import { REACT_DASHBOARD_PANEL } from "../actions/EndPoints";
import CompanyBackgroundImg from "../assets/CompanyBackgroundImg.svg";
import QRCodeICON from "../assets/QRCode";
import SwitchImage from "../assets/SwitchImage";
import { getCompanyInfo } from "../slices/Company/CompanySlice";
import { LinkForQRCode } from "../slices/Invitations/InvitationsSlice";
import { selectCompany, switchCompanies } from "../slices/onboard/LoginSlice";
import { ThemeContext } from "../theme/ThemeContext";
import CommonUtil from "../Util/CommonUtils";
import DialogBox from "./DialogBoxComponent/DialogBox";
import ProfileContext from "./ProfileContext";
import Toast from "./ToastContainer/CustomToast";

function SwitchCompany(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const store = useSelector((state) => state);
  const [isSelected, setIsSelected] = useState(false);
  const [companyCode, setCompanyCode] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const { darkMode, setDarkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [hovered, setHovered] = useState(false);

  const {
    companyProfilePic,
    setCompanyProfilePic,
    companyProfile,
  } = useContext(ProfileContext);

  const onMouseOverHandleChange = (event) => {
    setIsSelected(true);
    setCompanyCode(event.target.value);
  };

  const onMouseLeaveHandleChange = (event) => {
    setIsSelected(false);
    setCompanyCode(event.target.value);
  };

  useEffect(() => {
    if (CommonUtil.isEmpty(companyList)) loadCompanies();
  }, []);

  useEffect(() => {
    if (!CommonUtil.isEmptyString(companyCode)) {
      VerifyCompany(companyCode);
    }
  }, [companyCode]);

  const loadCompanies = () => {
    dispatch(switchCompanies())
      .unwrap()
      .then((data) => {
        if (decoded_jwtToken.companyType !== "CUSTOMER") {
          setDarkMode(false);
        }
        const companiesArray = CommonUtil.isEmpty(data.data)
          ? []
          : data.data.companies;
        const com = data.data.companies.filter((itm) => {
          return itm.id === localStorage.getItem("companyId");
        });
        const companyId = localStorage.getItem("companyId");
        const indexToMove = companiesArray.findIndex(
          (company) => company.id === companyId
        );
        if (indexToMove !== -1) {
          const companyToMove = companiesArray.splice(indexToMove, 1)[0];
          companiesArray.unshift(companyToMove);
        }
        setCompanyList(CommonUtil.isEmpty(data.data) ? [] : companiesArray);
        setCompanyProfilePic(
          com[0].companyLogo !== undefined
            ? data.data.imagePreSignedURL + com[0].companyLogo
            : ""
        );
      })
      .catch((er) => {});
  };

  const VerifyCompany = (code) => {
    if (CommonUtil.isEmptyString(code)) {
      Toast(t("VERIFYCOMP0001"), "error");
      return;
    }
    const payload = {
      companyCode: code,
      companyId: "",
      type: "",
      fcmToken: "",
    };
    dispatch(selectCompany(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0011") {
          localStorage.removeItem(process.env.REACT_APP_TEMP_TOKEN);
          localStorage.setItem(
            process.env.REACT_APP_ACCESS_TOKEN,
            "Bearer " + data.data.access_token
          );
          localStorage.setItem(
            process.env.REACT_APP_REFRESH_TOKEN,
            data.data.refresh_token
          );
          const decoded = jwt_decode(data.data.access_token);
          localStorage.setItem("companyId", decoded.companyId);
          localStorage.setItem("companyName", decoded.companyName);
          localStorage.setItem("companyCode", payload.companyCode);
          window.location.reload();
          if (decoded.companyType === "PARTNER") {
            window.location.href = REACT_DASHBOARD_PANEL;
          }
          setCompanyName(decoded.companyName);
          dispatch(getCompanyInfo())
            .unwrap()
            .then((data) => {
              if ((data.code = "UASI0000")) {
                setCompanyProfilePic(data.data.imagePreSignedURL);
              }
            });
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => {});
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setOpenCreateCompany(false);
    setAnchorEl(event.currentTarget);
  };

  const location = useLocation();

  useEffect(() => {
    setAnchorEl(null);
  }, [location]);

  const [openQR, setOpenQR] = React.useState(false);
  const handleOpenQR = () => {
    setOpenQR(true);
    setDiaLogBoxBlur(true);
  };

  const handleCloseQR = () => {
    setOpenQR(false);
    setDiaLogBoxBlur(false);
  };
  const [openCreateCompany, setOpenCreateCompany] = React.useState(false);

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setOpenCreateCompany(false);
    setAnchorEl(null);
  };

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const [link, setLink] = useState(0);

  var urlValue = window.location.href;
  var url = new URL(urlValue);
  var code = url.searchParams.get("code");

  const config = {
    headers: { companyId: localStorage.getItem("companyId") },
  };

  useEffect(() => {
    loadCompany();
  }, [store.profile.profileUpdated, companyProfile]);

  useEffect(() => {
    dispatch(LinkForQRCode(code, config))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0511") {
          setLink(data.data);
        }
      });
  }, []);

  // download QR code
  const handleQRCode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const loadCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0026") {
          setCompanyProfilePic(data.data.imagePreSignedURL);
          setCompanyName(data.data.name);
        }
      })
      .catch((er) => {});
  };

  return decoded_jwtToken.companyType !== "NONE" &&
    decoded_jwtToken.partnerType !== "DEALER" ? (
    <React.Fragment>
      <ClickAwayListener onClickAway={handleClose}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            gap: 2,
          }}
        >
          <Tooltip title={"Switch Company"}>
            <IconButton
              onClick={handleClick}
              size="small"
              disableRipple
              disabled={!!decoded_jwtToken.tokenType}
              sx={{
                ml: 2,
                mr: 5,
                mb: "2px",
                borderRadius: "5px",
                opacity: 1,
                backgroundColor: darkMode ? "#021C31" : "#F2F2F2",
                "&:hover": {
                  opacity: 1,
                  backgroundColor: darkMode ? "#021C31" : "#F2F2F2",
                },
              }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar
                src={
                  companyProfilePic
                    ? companyProfilePic
                    : darkMode
                    ? companyProfileDark
                    : companyProfileLight
                }
                sx={{
                  "& img": {
                    objectFit: companyProfilePic ? "" : "none",
                  },
                  backgroundColor: darkMode
                    ? "rgba(78, 96, 111, 1)"
                    : "#0F5A9C33",
                  "&:hover": {
                    backgroundColor: darkMode ? "" : "#00000033",
                  },
                  height: 28,
                  width: 28,
                  margin: "4px 8px 4px 8px",
                }}
              />

              <div>
                <Typography
                  style={{
                    color: darkMode ? "#fff" : "#2281AB",
                    marginLeft: 0.5,
                  }}
                >
                  <Typography
                    style={{
                      color: darkMode ? "#fff" : "#2281AB",
                      marginLeft: 0.5,
                    }}
                  >
                    {companyName}
                  </Typography>
                </Typography>
              </div>
              {open ? (
                <KeyboardArrowUpIcon
                  sx={{
                    fontSize: 20,
                    paddingTop: "1.5px",
                    color: darkMode ? "#fff" : process.env.REACT_APP_ICON,
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    fontSize: 20,
                    paddingTop: "1.5px",
                    color: darkMode ? "#fff" : process.env.REACT_APP_ICON,
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </ClickAwayListener>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        style={{
          // border: "0.5px solid lightgray",
          borderRadius: "5px",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            bgcolor: darkMode
              ? "rgba(15, 90, 156, 0.8)"
              : process.env.REACT_APP_BG_HEADER_LOGO,
            height: "89px",
            overflow: "visible",
            mt: 1.5,
            boxShadow: "none !importent",
            backgroundImage: `url(${CompanyBackgroundImg})`,
            backgroundPosition: "bottom right",
            backgroundRepeat: "no-repeat",
            opacity: 0.8,

            "& .MuiAvatar-root": {
              width: 50,
              height: 50,
              ml: 1,
              mr: 1,
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              backgroundColor: "#f1efef7d",
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: darkMode
                ? "rgba(15, 90, 156, 0.8)"
                : process.env.REACT_APP_BG_HEADER_LOGO,
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <div>
          <Grid style={{ margin: "8px", display: "flex", direction: "row" }}>
            <div
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <Avatar>
                <SwitchImage hovered={hovered} fill={"#fff"} />
              </Avatar>
            </div>
            <Grid
              style={{
                margin: "2px",
                marginTop: "-7px",
              }}
            >
              <Typography
                noWrap
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  color: darkMode ? "rgba(221, 221, 221, 1)" : "#FFFFFF",
                }}
              >
                {decoded_jwtToken.companyName}
              </Typography>

              <Typography
                noWrap
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  color: darkMode ? "rgba(221, 221, 221, 1)" : "#FFFFFF",
                }}
              >
                {decoded_jwtToken.email}
              </Typography>
              <div
                style={{
                  color: darkMode ? "rgba(221, 221, 221, 1)" : "#FFFFFF",
                }}
              >
                {decoded_jwtToken.roleName}
              </div>
            </Grid>
            <Grid style={{ marginLeft: "20px" }}>
              {" "}
              <Avatar onClick={handleOpenQR}>
                <QRCodeICON />
              </Avatar>
            </Grid>
          </Grid>
          {process.env.REACT_APP_ENVIRONMENT === "USA" ? "" : <Divider />}
          {process.env.REACT_APP_ENVIRONMENT === "USA" && (
            <div
              style={{
                height: companyList.length === 1 ? "110px" : "250px",
                width: "237",
                overflowY: "auto",
                // border: '0.5px solid lightgray',
                borderRadius: "3px",
                marginTop: "-7px",
                backgroundColor: darkMode ? "#1c354b" : "#fff",
              }}
            >
              <PerfectScrollbar
                style={{
                  backgroundColor: darkMode ? " #1c354b" : "#fff",
                  color: darkMode ? "#fff" : "black",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    color: darkMode ? "rgba(221, 221, 221, 1)" : "black",
                    paddingLeft: "15px",
                    paddingTop: "11px",
                    marginBottom: "10px",
                    fontWeight: 400,
                  }}
                >
                  {t("COMP0009")}
                </Typography>

                {companyList.map((item) => (
                  <Box>
                    <MenuItem
                      onClick={() => {
                        setCompanyCode(item.code);
                      }}
                      className={
                        decoded_jwtToken.companyCode === item.code
                          ? "switchCompanyList"
                          : ""
                      }
                      value={item.code}
                      onMouseOver={() => onMouseOverHandleChange}
                      onMouseLeave={() => onMouseLeaveHandleChange()}
                      sx={{
                        backgroundColor:
                          decoded_jwtToken.companyCode === item.code
                            ? darkMode
                              ? "rgb(60, 64, 75) !important"
                              : "rgb(254, 242, 237) !important"
                            : "transparent !important",

                        "&:hover": {
                          backgroundColor:
                            decoded_jwtToken.companyCode === item.code
                              ? darkMode
                                ? "rgb(60, 64, 75) !important"
                                : "rgb(254, 242, 237) !important"
                              : "",
                        },

                        ...(darkMode && {
                          "&.MuiMenuItem-root:hover": {
                            backgroundColor: "rgb(40, 63, 84) !important",
                          },
                        }),

                        color:
                          decoded_jwtToken.companyCode === item.code
                            ? "rgb(242, 130, 76)"
                            : darkMode
                            ? "#fff"
                            : "black",
                        fontSize: "14px",
                        borderRadius: "10px",
                        margin: "0px 10px 5px",
                      }}
                    >
                      <Radio
                        checked={decoded_jwtToken.companyCode === item.code}
                        value={item.code}
                        onClick={() => setCompanyCode(item.code)}
                        sx={{
                          "&.MuiRadio-root": {
                            color: darkMode
                              ? "rgb(255, 255, 255) !important"
                              : "rgba(0, 0, 0, 0.61) !important",
                          },
                          "&.Mui-checked": {
                            color: "#f2824c !important",
                          },
                        }}
                      />
                      <Typography
                        noWrap
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.name}
                      </Typography>
                    </MenuItem>
                  </Box>
                ))}
              </PerfectScrollbar>
            </div>
          )}
        </div>
      </Menu>
      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            Download QR Code
          </span>
        }
        acceptText="Download"
        cancelText="Cancel"
        fullWidth={true}
        onClose={handleCloseQR}
        cancel={handleCloseQR}
        onSubmit={handleQRCode}
        open={openQR}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems={"center"}
          style={{ backgroundColor: darkMode ? " #1c354b" : "#fff" }}
        >
          <Grid
            container
            style={{
              minHeight: "10vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <QRCode
              value={link}
              size={200}
              id="qrCodeEl"
              fgColor={darkMode ? "#FFFFFF" : "#000000"}
              bgColor={darkMode ? "#0F273B" : "#FFFFFF"}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </React.Fragment>
  ) : null;
}

export default SwitchCompany;
